import * as React from 'react';
import { styles } from './styles';
import { DesignSection } from '../../../../types';
import { ChevronDown } from '@routes/event/create/components/ChevronDown';

export interface DemoSectionProps {
  open: boolean;
  onSectionToggle: React.MouseEventHandler<HTMLButtonElement>;
}

interface Props {
  section: DesignSection;
  name: string;
  subtitle: string | JSX.Element | null;
}

export const DemoSection: React.SFC<Props & DemoSectionProps> = ({
  open,
  section,
  name,
  subtitle,
  onSectionToggle,
  children
}) => {
  return (
    <div className={styles.designOption}>
      <button onClick={onSectionToggle} value={section} className={styles.designOptionButton}>
        <div className={styles.optionTitleContainer}>
          <div className={styles.optionTitle}>{name}</div>
          <div style={{ marginLeft: 8, alignSelf: 'center' }}>
            <ChevronDown className={styles.chevron(open)} />
          </div>
        </div>
        {subtitle && <small className={styles.optionSubtitle}>{subtitle}</small>}
      </button>
      {open && <div className={styles.optionContent(!!children)}>{children}</div>}
    </div>
  );
};
